import React, { useEffect, useState } from 'react'

import ProcessContainerUI from './ProcessContainerUI'

const ProcessContainer = ({
  data,
  toggleActionModal,
  toggleDeleteActionModal,
  isOpenCopyContainerModal,
  toggleCopyContainerModal,
  isOpenDeleteContainerModal,
  toggleDeleteContainerModal,
  onChangeSmartChatCollapse,
  containerCollapse
}) => {
  const [isDisabled, setIsDisabled] = useState(false)
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [isOpenOptionsSelector, setIsOpenOptionsSelector] = useState(false)

  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed && data.containerType === 'onProcess') {
      if (!data.actionList.length) return setIsDisabled(false)

      for (const action of data.actionList) {
        if (!action.botActionList.length) {
          return setIsDisabled(true)
        } else {
          if (isDisabled) setIsDisabled(false)
        }
      }
    }

    return () => isSubscribed = false
  }, [data])

  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed && containerCollapse) setIsCollapsed(containerCollapse.isOpen)

    return () => isSubscribed = false
  }, [containerCollapse])

  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed && isOpenOptionsSelector) setIsOpenOptionsSelector(false)

    return () => isSubscribed = false
  }, [isOpenCopyContainerModal, isOpenDeleteContainerModal])

  const toggleOptionsSelector = () => setIsOpenOptionsSelector(!isOpenOptionsSelector)

  return (
    <ProcessContainerUI
      data={data}
      isOpenOptionsSelector={isOpenOptionsSelector}
      toggleOptionsSelector={toggleOptionsSelector}
      toggleActionModal={toggleActionModal}
      toggleDeleteActionModal={toggleDeleteActionModal}
      toggleCopyContainerModal={toggleCopyContainerModal}
      toggleDeleteContainerModal={toggleDeleteContainerModal}
      onChangeSmartChatCollapse={onChangeSmartChatCollapse}
      isCollapsed={isCollapsed}
      isDisabled={isDisabled}
    />
  )
}

export default ProcessContainer
